import React from 'react'
import styled from 'styled-components'
import { SIZES } from '../../constants'

const Wrapper = styled.div`
    display: flex;
    flex-wrap: nowrap;
    height: 126px;
    overflow: hidden;
    border-radius: 6px;
    background: url('${STATICS_PATH}images/euro/background.png') left center no-repeat;
    margin: 0 0 18px;

    @media (max-width: ${SIZES.BREAKPOINT_MD - 1}px) {
        margin: 20px 0 24px;
    }

    @media (max-width: ${SIZES.BREAKPOINT_XS - 1}px) {
        height: 104px;
        background-size: auto 104px;
        margin: 20px 0;
    }
`

const LeftColumn = styled.div`
    flex: auto;
    height: 100%;
    position: relative;
`

const RightColumn = styled.div`
    flex: 0 0 406px;
    padding-left: 25px;
    height: 100%;
    overflow: hidden;
    background: url('${STATICS_PATH}images/euro/banner_right.png') right center no-repeat;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-wrap: nowrap;

    @media (max-width: ${SIZES.BREAKPOINT_XS - 1}px) {
        background-size: auto 104px;
        flex: 0 0 330px;
    }

    @media (max-width: 360px) {
        flex: 0 0 100%; 
        padding-left: 8px;       
    }
`

const LogoLink = styled.a`
    display: block;
    width: 140px;
    height: 100%;

    @media (max-width: ${SIZES.BREAKPOINT_XS - 1}px) {
        position: absolute;
        left: 0;
        top: 0;
        width: 120px;
    }

    @media (max-width: 400px) {
        display: none;       
    }
`

const Button = styled.a`
    display: block;
    text-transform: uppercase;
    flex: 0 0 162px;
    height: 32px;
    background: #fff;
    line-height: 34px;
    text-align: center;
    color: #1C69BF;
    font-size: 12px;
    text-decoration: none;
    border-radius: 4px;
    font-weight: 700;
    margin: 0 25px;

    &:hover {
        text-decoration: none;
        background: #C5D6EB;
    }

    @media (max-width: ${SIZES.BREAKPOINT_XS - 1}px) {
        flex: 0 0 125px;
        height: 25px;
        line-height: 25px;
        font-size: 10px;        
    }
`

const LinksBox = styled.div`
    flex: auto;
    z-index: 100;
`

const Link = styled.a`
    display: block;
    color: #fff;
    border-bottom: 1px dashed #C5D6EB;
    line-height: 22px; 
    font-size: 13px;
    text-align: right;

    &:hover {
        color: #fff;
        text-decoration: underline; 
    }

    &:last-child {
        border: none;
    }

    @media (max-width: ${SIZES.BREAKPOINT_XS - 1}px) {
        line-height: 20px; 
        font-size: 10px;       
    }
`

export default () => (
  <Wrapper>
    <LeftColumn>
      <LogoLink href='https://sport.aktualne.cz/fotbal/euro/me-fotbal/r~7eacc73ac76411ebbc3f0cc47ab5f122'/>
    </LeftColumn>
    <RightColumn>
      <LinksBox>
        <Link href='https://sport.aktualne.cz/fotbal/euro/me-fotbal/r~7eacc73ac76411ebbc3f0cc47ab5f122/#content-id=4'>
          Statistiky mistrovství »
        </Link>
        <Link href='https://sport.aktualne.cz/fotbal/euro/me-fotbal/r~7eacc73ac76411ebbc3f0cc47ab5f122/#content-id=1'>
          Play Off »
        </Link>
        <Link href='https://sport.aktualne.cz/fotbal/euro/me-fotbal/r~7eacc73ac76411ebbc3f0cc47ab5f122/#content-id=3'>
          Česká reprezentace »
        </Link>
        <Link href='https://sport.aktualne.cz/fotbal/euro/me-fotbal/r~7eacc73ac76411ebbc3f0cc47ab5f122/'>
          Související články »
        </Link>
      </LinksBox>
      <Button href='https://sport.aktualne.cz/fotbal/euro/me-fotbal/r~7eacc73ac76411ebbc3f0cc47ab5f122/#content-id=4'>
        VŠECHNY STATISTIKY
      </Button>
    </RightColumn>
  </Wrapper>
)
